import React from 'react';

export type JourneyStatusBannerVariant = 'status' | 'error';

export interface JourneyStatusBannerProps {
  message?: React.ReactNode;
  variant?: JourneyStatusBannerVariant;
  className?: string;
  role?: 'alert' | 'status';
}

function cx(...classes: Array<string | false | null | undefined>) {
  return classes.filter(Boolean).join(' ');
}

export const JourneyStatusBanner: React.FC<JourneyStatusBannerProps> = ({
  message,
  variant = 'status',
  className = 'form-alert',
  role,
}) => {
  if (!message) return null;

  return (
    <div
      className={cx(className, variant === 'error' && 'is-error')}
      role={role || (variant === 'error' ? 'alert' : 'status')}
    >
      {message}
    </div>
  );
};

export const StatusMessage: React.FC<
  Omit<JourneyStatusBannerProps, 'variant'>
> = (props) => <JourneyStatusBanner {...props} variant="status" />;

export const ErrorBanner: React.FC<
  Omit<JourneyStatusBannerProps, 'variant'>
> = (props) => <JourneyStatusBanner {...props} variant="error" />;

export default JourneyStatusBanner;
